<script>
/* eslint-disable */
export default {
	name: "Popup_success",
	props: {
		isActiveSuccess: {
			type: Boolean,
			required: true,
		},
	},
	methods: {
		popupToggle() {
			// console.log("popupToggle");
			const _this = this;
			_this.$emit("update:isActiveSuccess", false);
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
